import Fade from '@mui/material/Fade';
export default Fade;
export * from '@mui/material/Fade';
